import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap-grid.min.css';
import './App.css';
import  Home from './components/landing-page';
import Navbar from './components/navbar';
import Contact from './components/contact';
import Skills from './components/skills';
import Project from './components/projects';
import About from './components/about';
class App extends Component {
 
  render() {
    return (
<div className="App">
        <Navbar />
        <Home />
        <About/>
        <Project />
        <Contact />
        <Skills />
        <codersrank-widget username="rohaanmd"></codersrank-widget>
      </div>
    );
  }
}



export default App;
